'use strict';

// Notification type → data category
const NOTIF_CATEGORY = {
  // Schedule changes
  practice_bumped: 'schedule',
  practice_changed: 'schedule',
  practice_assigned: 'schedule',
  adhoc_confirmed: 'schedule',
  manual_override: 'schedule',
  practice_cancelled_fd: 'schedule',
  practice_deleted_fd: 'schedule',
  practice_cancelled_coach: 'schedule',
  practice_edited_coach: 'schedule',
  practice_moved: 'schedule',

  // Games
  makeup_tentative: 'games',
  makeup_confirmed: 'games',
  makeup_rejected: 'games',
  game_conflict_nudge: 'games',

  // Practice requests
  new_practice_request: 'requests',
  request_withdrawn: 'requests',
  request_resubmitted: 'requests',
  request_approved: 'requests',
  request_alternatives_offered: 'requests',
  request_rejected: 'requests',

  // Association / role requests
  assoc_request_submitted: 'requests',
  assoc_request_approved: 'requests',
  assoc_request_rejected: 'requests',
  role_granted: 'requests',
  role_revoked: 'requests',
  coach_added_to_team: 'requests',
  coach_removed_from_team: 'requests',

  // Field closings
  field_closed: 'closings',

  // Maintenance / equipment
  maintenance_report_submitted: 'maintenance',
  maintenance_report_response: 'maintenance',
  maintenance_report_resolved: 'maintenance',
  equipment_left_submitted: 'maintenance',
  equipment_left_response: 'maintenance',
  equipment_left_resolved: 'maintenance',

  // Announcements
  announcement: 'announcements',
};

// Route prefix → which data categories make it stale.
// Dashboard pages aggregate multiple data sources, so they're affected by more categories.
const ROUTE_CATEGORIES = {
  '/schedule':       ['schedule', 'games', 'closings'],
  '/fd-home':        ['schedule', 'games', 'requests', 'closings', 'maintenance'],
  '/coach-home':     ['schedule', 'games', 'requests', 'maintenance', 'announcements'],
  '/ra-home':        ['games'],
  '/games':          ['games'],
  '/requests':       ['requests'],
  '/user-requests':  ['requests'],
  '/closings':       ['closings', 'schedule'],
  '/maintenance':    ['maintenance'],
  '/announcements':  ['announcements'],
  '/division':       ['schedule', 'games'],
};

function currentRoute() {
  return (location.hash.replace(/^#/, '') || '/schedule').split('?')[0];
}

/**
 * Called when a notification arrives via SSE. If the current page displays
 * data affected by this notification type, shows a non-intrusive banner
 * prompting the user to refresh.
 */
export function checkStaleNotification(type) {
  const cat = NOTIF_CATEGORY[type];
  if (!cat) return;

  // Don't show while a modal is open (user may be editing).
  if (document.querySelector('.modal-overlay')) return;

  // Banner already visible — no need to stack.
  if (document.querySelector('.stale-banner')) return;

  const route = currentRoute();
  // Sorted longest-first so /schedule/day matches before /schedule.
  const sorted = Object.keys(ROUTE_CATEGORIES).sort((a, b) => b.length - a.length);
  const prefix = sorted.find(p => route.startsWith(p));
  if (!prefix) return;

  if (!ROUTE_CATEGORIES[prefix].includes(cat)) return;

  showStaleBanner();
}

function showStaleBanner() {
  const banner = document.createElement('div');
  banner.className = 'stale-banner';

  const msg = document.createElement('span');
  msg.className = 'stale-banner-msg';
  msg.textContent = 'New updates available';

  const action = document.createElement('button');
  action.className = 'stale-banner-action';
  action.textContent = 'Refresh';
  action.addEventListener('click', () => {
    banner.remove();
    window.__router?.();
  });

  const close = document.createElement('button');
  close.className = 'stale-banner-close';
  close.textContent = '\u00d7';
  close.addEventListener('click', e => {
    e.stopPropagation();
    dismiss(banner);
  });

  banner.append(msg, action, close);
  document.body.appendChild(banner);
  requestAnimationFrame(() => banner.classList.add('stale-banner--show'));
}

function dismiss(banner) {
  banner.classList.remove('stale-banner--show');
  setTimeout(() => banner.remove(), 200);
}

/** Remove the banner (e.g. on navigation). */
export function dismissStaleBanner() {
  const b = document.querySelector('.stale-banner');
  if (b) dismiss(b);
}
